// extracted by mini-css-extract-plugin
export default {"preview":"paymentPreviewModal_preview__Z1qfl","cta":"paymentPreviewModal_cta__Ay6ju","greyBtn":"paymentPreviewModal_greyBtn__pG7ml"};